import request from '@/utils/request'

let WarehouseApi = {

  /*仓库列表*/
  list(data) {
    return request._post('/shop/plus.warehouse.Index/index', data);
},
/*添加仓库*/
add(data) {
    return request._post('/shop/plus.warehouse.Index/add', data);
},
/*修改仓库*/
edit(data) {
    return request._post('/shop/plus.warehouse.Index/edit', data);
},
/*删除仓库*/
del(data) {
    return request._post('/shop/plus.warehouse.Index/del', data);
},
/*仓库详情*/
detail(data) {
  return request._post('/shop/plus.warehouse.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.warehouse.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.warehouse.Setting/getSetting', data, errorback);
    },
}
export default WarehouseApi;



// WEBPACK FOOTER //
// ./src/api/warehouse.js